<template>
    <Layout :title="$t('booksList.title')" :content-class="'content--centered'">
        <div class="content__title-wrap">
            <h1 data-v-step="2" class="content__title">{{ $t('booksList.title') }}</h1>
            <router-link to="/podcasts" class="link">
                {{ $t('routes.podcasts') }}
            </router-link>
            <router-link v-if="!isListener" data-v-step="1" to="/upload" class="btn">
                {{ $t('booksList.upload') }}
            </router-link>
        </div>
        <BooksList />
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

import { BooksList } from '@speechki-frontend/core/book/components';

export default {
    name: 'BooksPage',
    components: {
        Layout,
        BooksList
    },
    computed: {
        isListener() {
            return this.$store.getters.isListener;
        }
    }
};
</script>
